<aside id="sidebar-switch"
  class="fixed top-0 left-0 z-40 w-72 h-screen transition-transform -translate-x-full lg:translate-x-0"
  aria-label="Sidebar">

  <div class="overflow-y-auto py-4 px-3 h-full bg-white border-r border-gray-200 dark:bg-gray-800 dark:border-gray-700">

    <a href="/" class="flex items-center pl-2 mb-5">
      <img src="/assets/images/logo.svg" class="w-[160px]" alt="bugatlas" />
    </a>

    <form class="flex items-center mb-4">
      <label for="simple-search" class="sr-only">Search</label>
      <div class="relative w-full">
        <div class="flex absolute inset-y-0 left-0 items-center pl-3 pointer-events-none">
          <svg aria-hidden="true" class="w-5 h-5 text-gray-500 dark:text-gray-400" fill="currentColor"
            viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M7 3a1 1 0 000 2h6a1 1 0 100-2H7zM4 7a1 1 0 011-1h10a1 1 0 110 2H5a1 1 0 01-1-1zM2 11a2 2 0 012-2h12a2 2 0 012 2v4a2 2 0 01-2 2H4a2 2 0 01-2-2v-4z">
            </path>
          </svg>
        </div>
        <input type="search" id="simple-search" (input)="onSearch($event)"
          class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full pl-10 p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
          placeholder="Search projects" required>

        <div id="tooltip-default" role="tooltip"
          class="absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium text-white transition-opacity duration-300 bg-gray-900 rounded-lg shadow-sm opacity-0 tooltip dark:bg-gray-700">
          Create new project
          <div class="tooltip-arrow" data-popper-arrow></div>
        </div>
      </div>
    </form>

    <ul class="space-y-1.5">
      <li>
        <a routerLink="/dashboard" routerLinkActive="bg-primary-500 text-white" class="active flex items-center p-2 text-base font-normal text-gray-900 rounded-lg hover:bg-primary-500
          hover:text-white dark:hover:bg-gray-700 group">

          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"
            class="w-5 h-5  transition duration-75">
            <path
              d="M3.5 11a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm3.5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm4.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5z" />
            <path
              d="M14 1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2zM2 14h12a1 1 0 0 0 1-1V5H1v8a1 1 0 0 0 1 1M2 2a1 1 0 0 0-1 1v1h14V3a1 1 0 0 0-1-1z" />
          </svg>

          <span class="ml-3">Dashboard</span>
        </a>
      </li>
      <li>
        <a routerLink="/profile" routerLinkActive="bg-primary-500 text-white"
          class="flex items-center p-2 text-base font-normal text-gray-900 rounded-lg dark:text-white hover:bg-primary-500 hover:text-white group">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16"
            class="w-5 h-5 ">
            <path
              d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6m2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0m4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4m-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10s-3.516.68-4.168 1.332c-.678.678-.83 1.418-.832 1.664z" />
          </svg>
          <span class="ml-3">Profile</span>
        </a>
      </li>
    </ul>


    <div
      class="flex justify-between items-center pt-3 pl-2 mt-5 mb-2 text-sm font-medium text-gray-500 uppercase border-gray-200 dark:text-gray-400 dark:border-gray-700">
      <h3>Projects</h3>
      <a data-tooltip-target="tooltip-default" data-modal-target="crud-modal" data-modal-toggle="crud-modal"
        class="pointer inline-flex text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700 focus:outline-none focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 rounded-lg text-sm p-2.5">
        <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd"
            d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V7z"
            clip-rule="evenodd"></path>
        </svg>
      </a>
    </div>

    <div id="tooltip-default" role="tooltip"
      class="absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium text-white transition-opacity duration-300 bg-gray-900 rounded-lg shadow-sm opacity-0 tooltip dark:bg-gray-700">
      Create new project
      <div class="tooltip-arrow" data-popper-arrow></div>
    </div>

    <ul class="space-y-1.5">
      <app-project-list></app-project-list>
      <!-- <li *ngFor="let project of projects">

        <ng-container *ngIf="project.project_id.is_deleted != 1">
          <ng-container>
            <a routerLink="/project/{{project.project_id._id}}/exceptions" (click)="onClickProject(project)"
              [ngClass]="project.project_id._id == activeProject ? 'active-menu':''"
              class="flex items-center p-2 text-base font-normal text-gray-900 rounded-lg dark:text-white hover:bg-priamry-500 dark:hover:bg-priamry-500 group">
              <span [ngStyle]="{'background-color': project.project_id.color_code}"
                class="h-5 w-5 text-primary-500 text-sm font-medium me-2 px-2.5 py-0.5 rounded dark:bg-primary-600 dark:text-primary-300"></span>
              <span class="ml-3">{{ project.project_id.name }}</span>
            </a>
          </ng-container>  -->

      <!-- <ng-container *ngIf="project.project_id._id != activeProject">
            <a routerLink="/project/{{project.project_id._id}}/exceptions"
              class="flex items-center p-2 text-base font-normal text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group">
              <span [ngStyle]="{'background-color': project.project_id.color_code }"
                class="h-5 w-5 text-primary-800 text-sm font-medium me-2 px-2.5 py-0.5 rounded dark:bg-primary-900 dark:text-primary-300"></span>
              <span class="ml-3">{{ project.project_id.name }}</span>
            </a>
          </ng-container> -->
      <!-- </ng-container> -->


      <!-- </li>  -->

      <li>
        <a data-modal-target="crud-modal" data-modal-toggle="crud-modal"
          class="pointer flex items-center p-2 text-base font-normal text-gray-500 rounded-lg dark:text-gray-400 hover:text-gray-900 dark:hover:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group">
          <svg aria-hidden="true"
            class="w-6 h-6 text-gray-400 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"
            fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"></path>
          </svg>
          <span class="ml-3">Add Project</span>
        </a>
      </li>
    </ul>
  </div>
</aside>

<app-navbar [imageUrl]="imageUrl"></app-navbar>




<!-- Create project modal -->
<div id="crud-modal" tabindex="-1" aria-hidden="true"
  class="hidden overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full">
  <div class="relative p-4 w-full max-w-md max-h-full">
    <!-- Modal content -->
    <div class="relative bg-white rounded-lg shadow dark:bg-gray-700">
      <!-- Modal header -->
      <div class="flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600">
        <h3 class="text-base md:text-lg font-medium text-gray-900 dark:text-white">
          Create New Project
        </h3>
        <button type="button"
          class="text-gray-400 bg-transparent absolute top-2.5 right-2.5 hover:bg-red-500 hover:text-white rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-600 dark:hover:text-white"
          data-modal-toggle="crud-modal">
          <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
          </svg>
          <span class="sr-only">Close modal</span>
        </button>
      </div>
      <!-- Modal body -->
      <form class="p-4 md:p-5" [formGroup]="projectForm" (ngSubmit)="createProject()">
        <!-- Error message -->
        <div *ngIf="errorMessage"
          class="p-4 mb-4 text-sm text-red-800 rounded-lg bg-red-50 dark:bg-gray-800 dark:text-red-400" role="alert">
          <span class="font-medium">{{ errorMessage }}</span>
        </div>

        <div class="grid gap-4 mb-4 grid-cols-2">
          <div class="col-span-2">
            <label for="name" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Name</label>
            <input type="text" formControlName="name" id="name"
              class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
              placeholder="Type project name">
              <div *ngIf="projectForm.get('name')?.hasError('required') && projectForm.get('name')?.touched"
              class="text-red-500 text-xs font-medium mt-2">
              Name is required
            </div>
          </div>

          <div class="col-span-2">
            <label for="description" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Project
              Description</label>
            <textarea formControlName="description" id="description" rows="4"
              class="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
              placeholder="Write project description here"></textarea>
          </div>
        </div>

        <!-- Submit button -->
        <button type="submit" [disabled]="loading" (click)="submitForm()"
          class="text-white inline-flex items-center bg-primary-500 hover:bg-primary-600 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-gray-600 dark:hover:bg-gray-700 dark:focus:ring-gray-800">
          <ng-container *ngIf="loading; else normalButton">
            <!-- Spinner HTML -->
            <svg class="animate-spin w-5 h-5 me-2 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M4 12a8 8 0 1116 0A8 8 0 014 12zm4-1v1h8v-1H8z"></path>
            </svg>
            <span>Processing...</span>
          </ng-container>
          <ng-template #normalButton>
            <svg class="me-1 -ms-1 w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd"
                d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z"
                clip-rule="evenodd"></path>
            </svg>
            {{ isUpdateMode ? 'Update project' : 'Add new project' }}
          </ng-template>
        </button>
      </form>


    </div>
  </div>
</div>